import {
  IMAGE_UPLOAD_MIN_PX,
  IMAGE_UPLOAD_MAX_PX,
  validateImageDimensions,
  readImageFileDimensions as readImageFileDimensionsShared,
  type ImageDimensions,
  type ImageDimensionError,
} from '../../../utils/imageDimensions';

export const CHARACTER_STYLE_UPLOAD_IMAGE_MIN_PX = IMAGE_UPLOAD_MIN_PX;
export const CHARACTER_STYLE_UPLOAD_IMAGE_MAX_PX = IMAGE_UPLOAD_MAX_PX;

export type { ImageDimensions };
export type CharacterStyleUploadImageDimensionError = ImageDimensionError;

export function validateCharacterStyleUploadImageDimensions(
  dimensions: ImageDimensions,
): CharacterStyleUploadImageDimensionError | null {
  return validateImageDimensions(dimensions, {
    min: CHARACTER_STYLE_UPLOAD_IMAGE_MIN_PX,
    max: CHARACTER_STYLE_UPLOAD_IMAGE_MAX_PX,
  });
}

export function readImageFileDimensions(file: File): Promise<ImageDimensions> {
  return readImageFileDimensionsShared(file);
}
